import { render, staticRenderFns } from "./dynamic-form-modal.vue?vue&type=template&id=b7c9c1b4&scoped=true&"
import script from "./dynamic-form-modal.vue?vue&type=script&lang=js&"
export * from "./dynamic-form-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7c9c1b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
